import * as React from 'react';
import { Spinner } from 'components/Common/Spinner';
import './workflowPreview.scss';

export interface IWorkflowPreviewProps {
    workflowRows: Nullable<string[][]>;
}

export default class WorkflowPreview extends React.PureComponent<IWorkflowPreviewProps> {
    render(): React.ReactNode {
        return (
            <div className="nomst-workflow-preview">
                <h3 className="nomst-workflow-preview__headline">Workflow Preview</h3>
                {this.renderWorkflowData()}
            </div>
        );
    }

    private renderWorkflowData(): React.ReactNode {
        const { workflowRows } = this.props;
        if (!workflowRows) {
            return <Spinner size={50}/>;
        }

        if (!workflowRows.length) {
            return null;
        }

        const maxColumns = workflowRows.reduce((accumulator, curr) => Math.max(accumulator, curr.length), 0);
        const rows = workflowRows.map((row, i) => {
            let blankCells: React.ReactNode = null;
            // create blank <td>s to fill out the table
            if (row.length < maxColumns) {
                const numCells = maxColumns - row.length;
                const blankArray = Array.from({ length: numCells });
                blankCells = blankArray.map((_, index) => <td key={`blank${index + row.length}`} />);
            }

            return (
                <tr key={i}>
                    {row.map((cell, idx) => <td key={`${cell} ${idx}`}>{cell}</td>)}
                    {blankCells}
                </tr>
            );
        });

        const headerArray = Array.from({ length: maxColumns });
        const headers = headerArray.map((_, i) => <th key={i}>Level {i + 1}<i className="icon-right" /></th>);
        return (
            <table className="nomst-workflow-preview__table">
                <thead>
                    <tr>{headers}</tr>
                </thead>
                <tbody>{rows}</tbody>
            </table>
        );
    }
}